import { formatStartToEndTime } from '@exam-center/utils';

export function formatSessionStartToEndTime(start: Date | null, end: Date | null) {
  if (!start || !end) {
    return '--:-- - --:--';
  }

  return formatStartToEndTime(start, end);
}
